<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="80"
    >
    <FormItem label="联系人" prop="constacts" >
        <Select v-model="formValidate.constacts">
          <Option
            v-for="item in contacts_list"
            :value="item.id"
            :key="item.id"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>
      
      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'
export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      contacts_list:[],
      formValidate: {
        constacts: '',
        wechat:'',
        id: ''
      },
      ruleValidate: {
        constacts: [
          {
            required: true,
            message: '必须选择联系人',
            trigger: 'change'
          }
        ],   
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    setEditData (params) {
      this.formValidate.constacts = params.wechat_id
      this.formValidate.wechat = params.wechat
      this.formValidate.id = params.id

    }, setWxContacts (contacts) {
      var data = new Array()
      for (var i = 0; i < contacts.length; i++) {
        data[i] = { id: contacts[i].userid, name: contacts[i].name }
      }
      this.contacts_list = data
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
  }
}
</script>
